import {
  Box,
  Button,
  VStack,
  Heading,
  Text,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";

import * as anchor from "@project-serum/anchor";

import evolution from "../audio/evolution.wav";
import ReactPlayer from "react-player";

interface ShopProps {
  connection: anchor.web3.Connection;
}

interface Equipment {
  name: string;
}

const EquipmentList: Equipment[] = [
  {
    name: "Helmet",
  },
  {
    name: "Weapon",
  },
  {
    name: "Trinket",
  },
  {
    name: "Pet",
  },
];

const EquipmentSlot = (props: Equipment) => {
  return (
    <Flex
      borderWidth="1px"
      p={4}
      h="60px"
      justifyContent="center"
      alignItems="center"
      flexFlow="column"
    >
      <Text>Empty</Text>
      <Text>{props.name}</Text>
    </Flex>
  );
};

const Shop = (props: ShopProps) => {
  return (
    <VStack spacing="0">
      <Box bg="tomato" w="100%" p="32px" color="white" textAlign="center">
        <Heading>Welcome to The Shop</Heading>
        <Text>
          Players will be able to spend their ingame gold on items and mint
          exclusive NFT's! (The Shop is a WIP and not implemented yet)
        </Text>
      </Box>

      <VStack textAlign="center" p="32px" bg="green.400" w="full">
        <Heading>Equipment</Heading>
        <SimpleGrid columns={4} spacing={10}>
          {EquipmentList.map((eq, idx) => (
            <EquipmentSlot key={idx} {...eq} />
          ))}
        </SimpleGrid>
      </VStack>

      <VStack textAlign="center" p="32px" bg="purple.400" w="full">
        <Heading>SlimeMint (WIP)</Heading>
        <Text textAlign="center">
          Players will be able to mint special edition NFT's that are only
          obtainable by using in-game currency!
        </Text>
        <Button variant="outlinePurple" disabled={true}>
          Mint
        </Button>
      </VStack>

      <VStack textAlign="center" p="32px" bg="blue.400" w="full">
        <Heading>Evolution (WIP)</Heading>
        <Text textAlign="center">
          Community members that have been airdropped our baby slime NFT's will
          be able to evolve them here once they have been leveled sufficiently
          in game!
        </Text>
        <Button variant="outlinePurple" disabled={true}>
          Evolve
        </Button>
      </VStack>
    </VStack>
  );
};

export default Shop;
